import { create } from 'zustand';
import type { AuthSession, User } from '@kick/types';

interface EstadoAuth {
  /**
   * El access token vive **solo en memoria**, nunca en localStorage.
   * Si se guardara, cualquier script inyectado en la página podría leerlo.
   * Al recargar se recupera la sesión con la cookie httpOnly de refresh.
   */
  accessToken: string | null;
  user: User | null;
  /** Mientras se intenta restaurar la sesión al cargar la página. */
  cargando: boolean;

  iniciar: (sesion: AuthSession) => void;
  actualizarToken: (token: string) => void;
  cerrar: () => void;
  terminarCarga: () => void;
}

export const useAuth = create<EstadoAuth>((set) => ({
  accessToken: null,
  user: null,
  cargando: true,

  iniciar: (sesion) =>
    set({
      accessToken: sesion.accessToken,
      user: sesion.user,
      cargando: false,
    }),

  actualizarToken: (accessToken) => set({ accessToken }),

  cerrar: () => set({ accessToken: null, user: null, cargando: false }),

  terminarCarga: () => set({ cargando: false }),
}));

/** Lectura del token fuera de React (la usa el interceptor de Axios). */
export const obtenerToken = (): string | null => useAuth.getState().accessToken;

export const haIniciado = (): boolean => !!useAuth.getState().accessToken;
